// Sunster 品牌定制 - 回到顶部交互逻辑
(function () {
  const btn = document.getElementById('back-to-top');
  if (!btn) return;

  // 滚动超过 300px 显示按钮
  function checkScroll() {
    if (window.scrollY > 300) {
      btn.classList.add('show');
    } else {
      btn.classList.remove('show');
    }
  }

  // 节流处理滚动事件，提升性能
  let ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        checkScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  // 点击平滑回到顶部
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  // 页面加载时检查一次
  checkScroll();
})();